/**
 * RF Cart Standalone
 *
 * Web component pra items avulsos no carrinho (sem _kit_slug).
 * Chama /cart/change.js diretamente (não passa pelo Rafobase).
 */

class RfCartStandalone extends HTMLElement {
  constructor() {
    super();
    this._busy = false;
    this._errorTimer = null;
  }

  connectedCallback() {
    this.addEventListener('click', this._handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._handleClick);
    clearTimeout(this._errorTimer);
  }

  _handleClick = (e) => {
    if (e.target.closest('[data-remove-item]')) {
      e.preventDefault();
      this._change(0);
    } else if (e.target.closest('[data-item-increment]')) {
      e.preventDefault();
      this._change(this._getCurrentQty() + 1);
    } else if (e.target.closest('[data-item-decrement]')) {
      e.preventDefault();
      const next = this._getCurrentQty() - 1;
      this._change(Math.max(0, next));
    }
  };

  _getCurrentQty() {
    const el = this.querySelector('[data-item-quantity]');
    return parseInt(el?.textContent?.trim() || '1', 10);
  }

  async _change(newQty) {
    if (this._busy) return;
    const key = this.dataset.lineKey;
    if (!key) return;

    this._busy = true;
    this.setAttribute('data-busy', '');

    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    try {
      const res = await fetch(`${rootUrl}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id: key, quantity: newQty }),
      });
      if (!res.ok) {
        const errText = await res.text().catch(() => '');
        throw new Error(`HTTP ${res.status}: ${errText}`);
      }
      // Re-render in-place via Section Rendering (mesmo padrão do nuture-cart-upsell):
      // o cart-items-component do Horizon re-busca o carrinho e faz morph do drawer.
      // NÃO recarregar a página — isso fechava o drawer e recarregava a loja (bug).
      this._busy = false;
      this.removeAttribute('data-busy');
      this._notifyTheme();
    } catch (err) {
      console.error('[rf-cart-standalone] Falha ao atualizar item:', err);
      this._showError('Não foi possível atualizar.');
      this.removeAttribute('data-busy');
      this._busy = false;
    }
  }

  /** Mesmo padrão do nuture-cart-upsell / RafobaseCart.refreshThemeCart: o
   *  cart-items-component do Horizon re-busca o carrinho e faz morph do drawer
   *  quando o evento vem sem sections — sem reload, drawer continua aberto. */
  _notifyTheme() {
    try {
      const evt = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
      evt.action = 'update';
      evt.promise = Promise.resolve({ detail: { source: 'rf-cart-standalone' } });
      document.dispatchEvent(evt);
    } catch {
      /* refresh é cosmético */
    }
  }

  _showError(message) {
    const errorEl = this.querySelector('[data-item-error]');
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.classList.remove('hidden');
    clearTimeout(this._errorTimer);
    this._errorTimer = setTimeout(() => {
      errorEl.classList.add('hidden');
      errorEl.textContent = '';
    }, 4000);
  }
}

if (!customElements.get('rf-cart-standalone')) {
  customElements.define('rf-cart-standalone', RfCartStandalone);
}
